import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Delivery } from '../../types';

type DeliveryState = Record<number, Delivery>;

const initialState: DeliveryState = {};

const deliverySlice = createSlice({
  name: 'delivery',
  initialState,
  reducers: {
    setDeliveriesToday(state, action: PayloadAction<Delivery[]>) {
      for (const delivery of action.payload) {
        state[delivery.id] = delivery;
      }
    },
    setDeliveriesForDate(state, action: PayloadAction<Delivery[]>) {
      for (const delivery of action.payload) {
        state[delivery.id] = delivery;
      }
    },
    pushDelivery(state, action: PayloadAction<Delivery>) {
      state[action.payload.id] = action.payload;
    },
  },
});

export const { setDeliveriesToday, setDeliveriesForDate, pushDelivery } = deliverySlice.actions;
export default deliverySlice.reducer;
